import React, { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useQuery } from "@hooks/useQuery";
import { GetComments } from "@graphql/configuration/queries/GetComments";
import SpinningLoader from "@components/loadingComponents/SpinningLoader";
import Comment from "@components/postComponents/comments/Comment";
import CommentInput from "@components/postComponents/comments/CommentInput";

// Renders <CommentsContainer /> that holds the list of comments.
export default function Comments({ post, setDownloadAppModalOpen }) {
  return post.commentCount !== 0 ? (
    <CommentsContainer
      post={post}
      setDownloadAppModalOpen={setDownloadAppModalOpen}
    />
  ) : (
    <div className="h-full border-t bg-commentsContainerBackgroundColor border-gray-200" />
  );
}

// Componenet that holds the list of comments and handles the infinite scrolling and fetching of more comments.
function CommentsContainer({ post, setDownloadAppModalOpen }) {
  const [fetchingMore, setFetchingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const { data, fetchMore, loading, resultsExtractor, nextVariablesExtractor } =
    useQuery(GetComments, {
      variables: {
        post,
      },
    });

  const comments = resultsExtractor(data);

  async function fetchMoreData() {
    if (!fetchingMore) {
      setFetchingMore(true);
      const nextVariables = nextVariablesExtractor(data);
      const variables = JSON.parse(
        JSON.stringify(nextVariables, (k, v) =>
          k === "__typename" ? undefined : v
        )
      );

      const moreComments = await fetchMore({ variables });
      if (!moreComments.data.getComments.comments.length) {
        setHasMore(false);
      }
      setFetchingMore(false);
    }
  }

  // If fetching comments still display the loader.
  if (loading)
    return (
      <div className="h-full border-t bg-commentsContainerBackgroundColor border-gray-200 text-center pt-6">
        <SpinningLoader size={6} />
      </div>
    );
  return (
    <>
      <div
        id="scrollableDiv"
        className="bg-commentsContainerBackgroundColor border-t border-b border-gray-200 flex-1 flex flex-col max-h-full overflow-y-auto pb-2 relative"
      >
        <InfiniteScroll
          dataLength={comments.length}
          next={() => fetchMoreData()}
          hasMore={hasMore}
          scrollThreshold={0.7}
          scrollableTarget="scrollableDiv"
        >
          {comments?.map((comment) => (
            <Comment post={post} comment={comment} />
          ))}
        </InfiniteScroll>
      </div>

      <CommentInput setDownloadAppModalOpen={setDownloadAppModalOpen} />
    </>
  );
}
